export const setUserToken = (token) => {
  if (!token) return;
  localStorage.setItem("userToken", token);
};
export const getUserToken = () => {
  return localStorage.getItem("userToken") || null;
};
// FIX 1: Manually stringify the object before saving
export const setUserData = (data) => {
  localStorage.setItem("userData", JSON.stringify(data));
};
// FIX 2: Add a try/catch block to prevent application crashes
export const getUserData = () => {
  const userData = localStorage.getItem("userData");
  if (!userData) return null;
  try {
    return JSON.parse(userData);
  } catch (error) {
    console.error("Error parsing userData cookie:", error);
    clearAuth();
    return null;
  }
};
export const clearAuth = () => {
  localStorage.clear();
};
export const setCustomDateType = (data) => {
  localStorage.setItem("customDate", JSON.stringify(data));
};
export const getCustomDateType = () => {
  const customDate = localStorage.getItem("customDate");
  return customDate ? JSON.parse(customDate) : null;
};
export const isValidEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};
export const isValidPassword = (password) => {
  const passwordRegex =
    /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
  return passwordRegex.test(password);
};
export const formatCurrency = (value) => {
  if (!value || isNaN(value)) return "$0.00";
  const num = Number(value);
  const abs = Math.abs(num);
  // If amount is 1 Million or more, show as $1.25M
  if (abs >= 1000000) {
    return `$${(num / 1000000).toFixed(2)}M`;
  }
  // Standard currency formatting ($1,234.56)
  return num.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
